import React, { useState } from "react";
import axios from "axios";
import Header from "./Header";

const LoginPage = () => {
  const [loginType, setLoginType] = useState("mobile");

  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");

  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);

  // Send Mobile OTP
  const sendMobileOtp = async () => {
    try {
      const mobiles = [mobile];

      const response = await axios.post(
        "https://plumber.metiermedia.com/api/send-otp",
        { mobiles }
      );

      console.log(response.data.message);
      setOtpSent(true);
    } catch (error) {
      console.error(
        "Failed to send OTP:",
        error.response?.data?.error || error.message
      );
    }
  };

  // Verify Mobile OTP
  const verifyMobileOtp = async () => {
    try {
      const res = await axios.post(
        "https://plumber.metiermedia.com/api/verify-otp",
        {
          mobile,
          otp,
        }
      );

      localStorage.setItem("user", JSON.stringify(res.data.user));

      window.location.href = "/cart";
    } catch (err) {
      console.error(
        err.response?.data?.error || err.message
      );
    }
  };

  // Send Email OTP
  const sendEmailOtp = async () => {
    try {
      const response = await axios.post(
        "https://plumber.metiermedia.com/api/send-email-otp",
        {
          email,
        }
      );

      console.log(response.data.message);
      setOtpSent(true);
    } catch (error) {
      console.error(
        "Failed to send Email OTP:",
        error.response?.data?.error || error.message
      );
    }
  };

  // Verify Email OTP
  const verifyEmailOtp = async () => {
    try {
      const res = await axios.post(
        "https://plumber.metiermedia.com/api/verify-email-otp",
        {
          email,
          otp,
        }
      );

      localStorage.setItem("user", JSON.stringify(res.data.user));

      window.location.href = "/cart";
    } catch (err) {
      console.error(
        err.response?.data?.error || err.message
      );
    }
  };

  // Change Login Type
  const changeLoginType = (type) => {
    setLoginType(type);
    setOtpSent(false);
    setOtp("");
  };

  return (
    <div>
      <Header />

      <div className="container">
        <div className="row">
          <div className="col-md-6 offset-md-3">

            <div className="card mt-4">
              <div className="card-body">

                {/* Mobile / Email Selection */}
                <div className="d-flex mb-4">

                  <button
                    type="button"
                    className={`btn ${
                      loginType === "mobile"
                        ? "btn-primary"
                        : "btn-outline-primary"
                    } w-50`}
                    onClick={() => changeLoginType("mobile")}
                  >
                    Mobile
                  </button>

                  <button
                    type="button"
                    className={`btn ${
                      loginType === "email"
                        ? "btn-primary"
                        : "btn-outline-primary"
                    } w-50`}
                    onClick={() => changeLoginType("email")}
                  >
                    Email
                  </button>

                </div>

                {/* MOBILE LOGIN */}
                {loginType === "mobile" && (
                  <>
                    {!otpSent ? (
                      <div>

                        <input
                          type="text"
                          className="form-control mb-3"
                          placeholder="Mobile Number"
                          value={mobile}
                          onChange={(e) =>
                            setMobile(e.target.value)
                          }
                        />

                        <button
                          className="btn btn-primary m-auto d-block"
                          onClick={sendMobileOtp}
                        >
                          Send OTP
                        </button>

                      </div>
                    ) : (
                      <div>

                        <input
                          type="text"
                          className="form-control mb-3"
                          placeholder="OTP"
                          value={otp}
                          onChange={(e) =>
                            setOtp(e.target.value)
                          }
                        />

                        <button
                          className="btn btn-primary m-auto d-block"
                          onClick={verifyMobileOtp}
                        >
                          Verify OTP
                        </button>

                      </div>
                    )}
                  </>
                )}

                {/* EMAIL LOGIN */}
                {loginType === "email" && (
                  <>
                    {!otpSent ? (
                      <div>

                        <input
                          type="email"
                          className="form-control mb-3"
                          placeholder="Email Address"
                          value={email}
                          onChange={(e) =>
                            setEmail(e.target.value)
                          }
                        />

                        <button
                          className="btn btn-primary m-auto d-block"
                          onClick={sendEmailOtp}
                        >
                          Send OTP
                        </button>

                      </div>
                    ) : (
                      <div>

                        <input
                          type="text"
                          className="form-control mb-3"
                          placeholder="OTP"
                          value={otp}
                          onChange={(e) =>
                            setOtp(e.target.value)
                          }
                        />

                        <button
                          className="btn btn-primary m-auto d-block"
                          onClick={verifyEmailOtp}
                        >
                          Verify OTP
                        </button>

                      </div>
                    )}
                  </>
                )}

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;